"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _UnmanagedMenuItem = _interopRequireDefault(require("./UnmanagedMenuItem"));

var _MoreOptions = _interopRequireDefault(require("./MoreOptions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MenuItem = function MenuItem(_ref) {
  var defaultOpen = _ref.defaultOpen,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["defaultOpen", "onClick", "disabled"]);

  var _useState = (0, _react.useState)(defaultOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = (0, _react.useCallback)(function (e, value, isLeafItem) {
    setOpen(function (previousState) {
      return !previousState;
    });
    onClick(e, value, isLeafItem);
  }, [onClick]);
  return (0, _jsxRuntime.jsx)(_UnmanagedMenuItem["default"], _objectSpread({
    open: open,
    disabled: disabled,
    onClick: handleClick
  }, otherProps));
};

MenuItem.propTypes = {
  /**
   * Should open the submenu in the beginning
   */
  defaultOpen: _propTypes.bool,
  onClick: _propTypes.func,
  disabled: _propTypes.bool
};
MenuItem.defaultProps = {
  defaultOpen: false,
  onClick: function onClick() {},
  disabled: false
};
MenuItem.MoreOptions = _MoreOptions["default"];
var _default = MenuItem;
exports["default"] = _default;
//# sourceMappingURL=MenuItem.js.map